import { TIcon } from '@hz-design-system/web-ui';

const bundleIcons: Record<string, TIcon> = {
  BASIC: 'plane_paper', // TODO remove after migration to new business-bundle service, this remains here to keep it backwards compatible
  PLUS: 'plane', // TODO remove after migration to new business-bundle service, this remains here to keep it backwards compatible
  SmbBasicBundle: 'plane_paper',
  SmbPlusBundle: 'plane',
};

export default bundleIcons;
